import React from "react"
import PropTypes from "prop-types"

const Search = ({
  style = {},
  fill = "currentColor",
  width = "20px",
  className = "search",
  viewBox = "0 0 20 20"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M20 18.586L18.586 20l-5.657-5.657 1.414-1.414L20 18.586zM7 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z"
    />
 </svg>

)

Search.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Search
